import { procoreClient } from "./client";

/**
 * Probe whether a scene's search database is ready to serve queries.
 *
 * The BIM Search DB `ping` endpoint runs the same shared-volume availability
 * check as the data endpoints: it returns `202 Accepted` while an OpenZFS
 * backfill is still in progress and `200 OK` once the scene is readable. This
 * is used to poll for recovery after a {@link SceneBackfillingError}.
 *
 * @returns `true` when the scene is ready (200), `false` while still backfilling (202).
 * Rejects for other (non-2xx) responses, which the caller treats as "keep waiting".
 */
export async function isProcoreSceneReady(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
    sceneVersionId: string;
    signal?: AbortSignal;
}): Promise<boolean> {
    return procoreClient<boolean>(
        `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/bim/scenes/${params.sceneId}/versions/${params.sceneVersionId}/ping`,
        {
            method: "GET",
            parseResponse: (res) => res.status !== 202,
            signal: params.signal,
        },
    );
}
